module.exports = __webpack_public_path__ + "media/Tommy '86 - Why Did I Say Goodbye (feat. Sally Shapiro).4d874cc3.mp3";